import React, { useMemo } from 'react';

const pad = (n) => String(n).padStart(2, '0');
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const periods = () => {
  const now = new Date();
  const ago = (days) => new Date(now.getTime() - days * 86400000);
  const year = now.getFullYear();
  return [
    { label: 'Last 30 days', from: ymd(ago(30)), to: '' },
    { label: 'Last 3 months', from: ymd(ago(90)), to: '' },
    { label: 'This year', from: `${year}-01-01`, to: '' },
    { label: 'Last year', from: `${year - 1}-01-01`, to: `${year - 1}-12-31` }
  ];
};

const topBy = (moments, pick) => {
  const counts = new Map();
  moments.forEach((m) => pick(m).forEach((x) => {
    const cur = counts.get(x.id) || { ...x, count: 0 };
    cur.count += 1;
    counts.set(x.id, cur);
  }));
  return Array.from(counts.values()).sort((a, b) => b.count - a.count).slice(0, 5);
};

const Chip = ({ onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className="rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-600 hover:border-slate-300 hover:bg-slate-50"
  >
    {children}
  </button>
);

// Quick ways back into past Moments, built from the loaded Moments. No AI is used.
export const MomentRediscover = ({ moments, onPick }) => {
  const people = useMemo(() => topBy(moments, (m) => m.people || []), [moments]);
  const origins = useMemo(() => topBy(moments, (m) => (m.origin ? [m.origin] : [])), [moments]);

  return (
    <div className="mb-6 space-y-3">
      <div>
        <p className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-400">Revisit a period</p>
        <div className="flex flex-wrap gap-2">
          {periods().map((p) => <Chip key={p.label} onClick={() => onPick({ from: p.from, to: p.to })}>{p.label}</Chip>)}
        </div>
      </div>
      {people.length > 0 && (
        <div>
          <p className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-400">Moments with</p>
          <div className="flex flex-wrap gap-2">
            {people.map((p) => <Chip key={p.id} onClick={() => onPick({ contactId: p.id })}>{p.full_name || 'Contact'} · {p.count}</Chip>)}
          </div>
        </div>
      )}
      {origins.length > 0 && (
        <div>
          <p className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-400">From</p>
          <div className="flex flex-wrap gap-2">
            {origins.map((o) => <Chip key={o.id} onClick={() => onPick({ originId: o.id })}>{o.label} · {o.count}</Chip>)}
          </div>
        </div>
      )}
    </div>
  );
};